import {environment} from './../../../environments/environment';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertController, ModalController} from '@ionic/angular';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MenuPage} from '../menu/menu.page';
import {AppComponent} from '../../app.component';
import {TranslateService} from '@ngx-translate/core';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {PreorderType} from 'src/smoothr-web-app-core/enums/PreorderType';
import {ScanQrModal} from 'src/app/components/scan-qr/scan-qr.component';
import {SelectTableModalComponent} from 'src/app/components/select-table-modal/select-table-modal.component';
import {SelectTableListComponent} from 'src/app/components/select-table-list/select-table-list.component';

@Component({
	selector: 'app-order',
	templateUrl: './order.page.html',
	styleUrls: ['order.page.scss']
})
export class OrderPage extends RepositoryDirective implements OnInit {
	static url = 'order';
	static failUrlWithPaymentParam = 'payment/fail/:payment';
	static cancelUrlWithPaymentParam = 'payment/cancel/:payment';
	static paymentFailUrl = 'payment/fail';
	static paymentCancelUrl = 'payment/cancel';
	loading = false;

	constructor(
		private translate: TranslateService,
		private snackbarCtrl: MatSnackBar,
		protected repository: RepositoryService,
		private router: Router,
		private modalCtrl: ModalController
	) {
		super(repository);
	}

	get title(): string {
		if (!OrderUtils.isPreorder(this.order)) {
			return '';
		}
		return this.translate.instant('menu_page.basket_title');
	}

	static navigate(router: Router) {
		return router.navigateByUrl(
			AppComponent.largeScreen ? MenuPage.url : OrderPage.url
		);
	}

	ngOnInit(): void {
		console.log('ngOnInit');
		super.ngOnInit();
		switch (window.location.pathname) {
			case '/' + OrderPage.url:
				break;
			case '/' + OrderPage.paymentCancelUrl:
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(
					this.translate.instant('order.payment_cancel'),
					null,
					{
						duration: 2000
					}
				);
				break;
			case '/' + OrderPage.paymentFailUrl:
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(
					this.translate.instant('order.payment_fail'),
					null,
					{
						duration: 5000
					}
				);
				break;
		}
	}
	backClick() {
		MenuPage.navigate(this.router);
	}

	async openSelectTableModal(openByToolbar?: boolean) {
		if (this.venue && this.order.preorder.type === PreorderType.INSIDE) {
			if (this.order.tableNumber === 'preorder_table' || openByToolbar) {
				// const selectTable = await ScanQrModal.show(this.modalCtrl, this.venue);
				const selectTable = await SelectTableListComponent.show(
					this.modalCtrl,
					this.venue,
					this.order
				);
				if (selectTable && selectTable?.number) {
					this.order.tableNumber = selectTable.number;
					this.order.table = selectTable._id;
					this.repository.order.emit(this.order);
				}
			}
		}
	}
}
